import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'antd/dist/antd.css';
import 'react-tabs/style/react-tabs.css';
import AuthProvider from './utils/auth/AuthProvider';
import ApolloClientProvider from './utils/ApolloClient';
import appInsightsInstance from './utils/appInsightsConfig';

if (
  process.env.REACT_APP_INSIGHT_CONNECTION_STRING &&
  (process.env.REACT_APP_ENVIRONMENT === 'development' ||
    process.env.REACT_APP_ENVIRONMENT === 'production')
) {
  try {
    appInsightsInstance.loadAppInsights();
  } catch (error) {
    console.error('Error initializing Application Insights:', error);
  }
}

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <ApolloClientProvider>
          <App />
        </ApolloClientProvider>
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
